class LWInhoud extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const nummer = this.getAttribute('nr') || '01';
        const link = this.getAttribute('link') || '#';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                width: 100%;
            }

            .item-container {
                display: flex;
                align-items: flex-start;
                padding: 0px 0;
                border-top: 3px solid #ff0080;
                gap: 10px;
                text-decoration: none;
                cursor: pointer;
            }


            /* Het grote cijfer links */
            .number {
                font-size: 60px;
                font-weight: 800;
                line-height: 1;
                color: white;
                opacity: 0.9;
                transform: translateY(5px);
                min-width: 50px;
            }

            /* De content rechts */
            .content {
                flex: 1;
                color: white;
            }

            ::slotted(h2) {
                margin: 0 0 15px 0;
                font-size: 40px;
                /* FIX: !important moet BUITEN de var() staan */
                font-weight: var(--inhoud-h2-weight, 900) !important;
                letter-spacing: 2px;
                line-height: 1.1;
            }


            ::slotted(h3) {
                margin: 0 0 10px 0;
                font-size: 30px;
                letter-spacing: 1px;
                font-weight: 900;
            }

    
            ::slotted(.inhoud-tekst) {
                padding-top: 10px;
                margin: 0; 
                font-size: 50px;      /* Iets groter gezet voor de leesbaarheid */
                font-weight: 400;
                line-height: 1.2;     /* Belangrijk: 1.2 zorgt dat de tekst niet wordt afgekapt */
                opacity: 0.85;        /* Iets minder doorzichtig voor meer 'body' */
                color: #ffffff;
                text-transform: none;
                display: block;       /* Forceert het element als blok */
            }



            /* Verwijder de lijn bij het laatste item als je dat mooier vindt */
            :host(:last-of-type) .item-container {
                border-bottom: none;
            }

            @media (min-width: 600px) {
                .item-container {
                    gap: 35px;
                    padding: 10px 0;
                }
                .number {
                    font-size: 160px;
                    min-width: 100px;
                    transform: translateY(-10px);
                }
            }
        </style>

        <a class="item-container" href="${link}">
            <div class="number">${nummer}</div>
            <div class="content">
                <slot></slot>
            </div>
        </a>
        `;
    }
}

customElements.define('lw-inhoud', LWInhoud);